// @ts-nocheck
import {ConfEnv} from "../config/config";
import publicRequest from "../Infra/http/public.request";

export const getAppConfigService = () => {
  return publicRequest.get(`${ConfEnv.API_URL.APP_CONFIG}`);
};
